import { render, staticRenderFns } from "./Reassurance.vue?vue&type=template&id=15af39c8"
import script from "./Reassurance.vue?vue&type=script&lang=js"
export * from "./Reassurance.vue?vue&type=script&lang=js"
import style0 from "./Reassurance.vue?vue&type=style&index=0&id=15af39c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports